import { mdiTownHall } from '@mdi/js'

export default {
  title: 'School Data',
  to: 'school-data-hod-list',
  icon: mdiTownHall,
  action: 'read',
  resource: 'SchoolDataHeadDepartment',
}
